
export function assertNever(value: never): never {
    const callstack = new Error().stack;
    throw new Error(`assertNever(value === ${JSON.stringify(value)}) should be unreachable but was reached with the following callstack:\n ${callstack}`);
}